import type { CMSComponent } from '@/components/cms/schemas';
import {
  CMSComponentSchema,
  PartialPageSlugSchema,
} from '@/components/cms/schemas';
import { z } from 'zod';

const PartialDataSchema = z.object({
  content: z.array(CMSComponentSchema),
  title: z.string(),
  slug: PartialPageSlugSchema,
});

export const PartialSchema = z.object({
  data: z.array(PartialDataSchema).nonempty(),
});

export interface PartialDataResponse {
  title: string;
  content: CMSComponent[];
  slug: z.infer<typeof PartialPageSlugSchema>;
}

export interface PartialResponse {
  data: {
    title: string;
    content: CMSComponent[];
    slug: z.infer<typeof PartialPageSlugSchema>;
  }[];
}
